//
//  types.ts
//  Supernova CLI
//
//  Created by Jiri Trecak.
//  Copyright © Supernova.io. All rights reserved.
//

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports

 
import type { PLLogger } from "@supernova-studio/pulsar-language"

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Types

export interface ExportConfiguration {
  accessToken: string
  apiUrl: string
  apiVersion?: string
  brandId?: string
  debugMode?: boolean
  designSystemId: string
  designSystemVersionId: string
  exportPath: string
  logger: PLLogger
  proxyUrl?: string
  themeId?: string
}

export enum ErrorCode {
  designSystemDescriptionFailed = "ERR_DESIGN_SYSTEM_DESCRIPTION_FAILED",
  documentationPublishingFailed = "ERR_DOCUMENTATION_PUBLISHING_FAILED",
  exportFailed = "ERR_EXPORT_FAILED",
  tokenSyncFailed = "ERR_TOKEN_SYNC_FAILED",
  workspaceDescriptionFailed = "ERR_WORKSPACE_DESCRIPTION_FAILED",
}
